import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { TooltipContentProps } from "@radix-ui/react-tooltip";
import styles from "./Tooltip.module.scss";
import classNames from "classnames";
import { Fragment, PropsWithChildren } from "react";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipArrow = TooltipPrimitive.TooltipArrow;
export const TooltipPortal = TooltipPrimitive.TooltipPortal;

export type TooltipVariant = "small" | "large";
export type TooltipSide = "bottom" | "top" | "left" | "right";
export type TooltipAlign = "start" | "center" | "end";
export interface TooltipProps extends TooltipContentProps {
  variant?: TooltipVariant;
  side?: TooltipSide;
  align?: TooltipAlign;
  className?: string;
  portal?: boolean;
}

export const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  PropsWithChildren<TooltipProps>
>((props, ref) => {
  const {
    className,
    sideOffset = 4,
    variant = "large",
    side = "bottom",
    portal = true,
    children,
    asChild,
    ...rest
  } = props;

  const PortalElement = portal ? TooltipPrimitive.Portal : Fragment;
  const tooltipClasses = asChild
    ? className
    : classNames(
        styles.tooltipContent,
        {
          [styles.variantSmall]: variant === "small",
          [styles.variantLarge]: variant === "large",
        },
        className,
      );

  return (
    <PortalElement>
      <TooltipPrimitive.Content
        ref={ref}
        side={side}
        sideOffset={sideOffset}
        className={tooltipClasses}
        {...rest}
      >
        {children}
        {!asChild && (
          <TooltipArrow className={styles.tooltipArrow}></TooltipArrow>
        )}
      </TooltipPrimitive.Content>
    </PortalElement>
  );
});

TooltipContent.displayName = "TooltipContent";
